import React, { useState } from 'react'
import { useBuyTransactionsQuery } from './store/ReduxApis';
import Footer from "./Footer";
import { TablePagination } from '@material-ui/core';

// const explorerBaseUrl = process.env.REACT_APP_BSC_EXPLORER_URL;
const explorerBaseUrl = "https://testnet.bscscan.com";

function BuyTransactions() {

    const trans = useBuyTransactionsQuery();
    const [userAddress, setUserAddress] = useState("")
    const [searchTerm, setSearchTerm] = useState("");
    const [presale, setPresale] = useState("");
    const [receiveAmt, setReceiveAmt] = useState("");
    const [spentAmt, setSpentAmt] = useState(""); 
    const [status, setStatus] = useState(""); 
    const [date, setDate] = useState("");

    console.log("Data Loaded:", trans?.data?.data);

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div>
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6 text">
                                <h1>Buy Transaction List</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item active">Buy Transaction List</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header cards">
                                        <h3 className="card-title">Get all the Buy Transaction details</h3>
                                    </div>

                                    <div className="card-body">
                                        <div className="pagination">
                                            <h6 className="page">Show 1 to {trans?.data?.data?.length} entries</h6>
                                            <TablePagination
                                                className="pagi"
                                                rowsPerPageOptions={[5, 10, 30]}
                                                component="div"
                                                count={trans?.data?.data?.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onChangePage={handleChangePage}
                                                onChangeRowsPerPage={handleChangeRowsPerPage}
                                            />
                                        </div>

                                        <div className="table-responsive">
                                            <table id="example" className="table table-bordered table-striped table-hover" datatable>
                                                <thead>
                                                    <tr>
                                                        <th>Wallet Address</th>
                                                        <th>Transaction Hash</th>
                                                        <th>Presale Round</th>
                                                        <th>Spent Amount</th>
                                                        <th>Receive Amount</th>
                                                        <th>Status</th>
                                                        <th>Date</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {trans && trans?.data?.data?.filter((value) => {
                                                        const transactionDate = new Date(Number(value.timestamp)).toLocaleDateString();
                                                        return (
                                                            (searchTerm === "" || value.txHash.toLowerCase().includes(searchTerm.toLowerCase())) &&
                                                            (presale === "" || value.tiername.toLowerCase().includes(presale.toLowerCase())) &&
                                                            (spentAmt === "" || value.sourceAmount.toLowerCase().includes(spentAmt.toLowerCase())) &&
                                                            (receiveAmt === "" || value.targetAmount.toLowerCase().includes(receiveAmt.toLowerCase())) &&
                                                            (userAddress === "" || value.from.toLowerCase().includes(userAddress.toLowerCase())) &&
                                                            (status === "" || value.status.toLowerCase().includes(status.toLowerCase())) &&
                                                            (date === "" || transactionDate.includes(date))
                                                        );
                                                    }).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(e => (
                                                        <tr className='tr' key={e.txHash}>
                                                            <td>{`${e.from.slice(0, 5)}...${e.from.slice(-5)}`}</td>
                                                            <td>
                                                                {`${e.txHash.slice(0, 5)}...${e.txHash.slice(-5)}`}
                                                                <button
                                                                    className="btn btn-sm btn-outline-primary ms-2"
                                                                    onClick={() =>
                                                                        window.open(`${explorerBaseUrl}/tx/${e.txHash}`, "_blank")
                                                                    }
                                                                >
                                                                    View
                                                                </button>
                                                            </td>
                                                            <td>{e.tiername}</td>
                                                            <td>{e.sourceAmount} {e.source}</td>
                                                            <td>{e.targetAmount} {e.target}</td>
                                                            <td>
                                                                <b>
                                                                    <span className="badge text-white badge-success">{e.status}</span>
                                                                </b>
                                                            </td>
                                                            <td>{new Date(Number(e.timestamp)).toLocaleDateString()}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>

                                                <tfoot>
                                                    <tr>
                                                        <th><input type="text" className="form-control" onChange={(e) => setUserAddress(e.target.value)} autoComplete="off" placeholder="Wallet Address" name="search-Id" /></th>
                                                        <th><input type="text" className="form-control" onChange={(e) => setSearchTerm(e.target.value)} autoComplete="off" placeholder="Transaction Hash" name="search-Id" /></th>
                                                        <th><input type="text" className="form-control" onChange={(e) => setPresale(e.target.value)} autoComplete="off" placeholder="Presale Round" name="search-Id" /></th>
                                                        <th><input type="text" className="form-control" onChange={(e) => setSpentAmt(e.target.value)} autoComplete="off" placeholder="Spent Amount" name="search-Id" /></th>
                                                        <th><input type="text" className="form-control" onChange={(e) => setReceiveAmt(e.target.value)} autoComplete="off" placeholder="Receive Amount" name="search-Id" /></th>
                                                        <th><input type="text" className="form-control" onChange={(e) => setStatus(e.target.value)} autoComplete="off" placeholder="Status" name="search-status" /></th>
                                                        <th><input type="text" className="form-control" onChange={(e) => setDate(e.target.value)} autoComplete="off" placeholder="Date" name="search-date" /></th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </div>
    )
}

export default BuyTransactions
